
import React from 'react';
import HeroContent from './hero/HeroContent';

const Hero = () => {
  return (
    <div className="relative min-h-[600px] w-full flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/home_background.avif')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-propertylk-darkblue/80 to-black/60" />
      </div>

      {/* Content */}
      <HeroContent />
    </div>
  );
};

export default Hero;
